function ensureWbModalInBody(modal) {
  if (modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }
}

function initWbInfoModal() {
  const modal = document.getElementById('wb-info-modal');

  if (!modal) {
    return null;
  }

  if (modal.dataset.wbInfoBound === '1') {
    return modal.__wbInfoApi ?? null;
  }

  modal.dataset.wbInfoBound = '1';
  ensureWbModalInBody(modal);

  const titleNode = document.getElementById('wb-info-modal-title');
  const contentNode = document.getElementById('wb-info-modal-content');
  const closeTargets = modal.querySelectorAll('[data-wb-info-close]');

  const closeModal = () => {
    modal.classList.add('hidden');
    modal.setAttribute('aria-hidden', 'true');
  };

  const openModal = ({ title = '', content = '' }) => {
    ensureWbModalInBody(modal);

    if (titleNode) {
      titleNode.textContent = title;
    }

    if (contentNode) {
      contentNode.innerHTML = content;
    }

    modal.classList.remove('hidden');
    modal.setAttribute('aria-hidden', 'false');
  };

  closeTargets.forEach((target) => {
    target.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.classList.contains('hidden')) {
      closeModal();
    }
  });

  const api = { openModal, closeModal };
  modal.__wbInfoApi = api;

  return api;
}

export { initWbInfoModal, ensureWbModalInBody };
